export default {
  resolved: false,
  requested: false,
  providerLoginInfos: {},
  username: null,
  rooms: [],
  claims: '',
  role: '',
};
